import { render, staticRenderFns } from "./product7.vue?vue&type=template&id=161bc6fd&scoped=true"
import script from "./product7.vue?vue&type=script&lang=js"
export * from "./product7.vue?vue&type=script&lang=js"
import style0 from "./product7.vue?vue&type=style&index=0&id=161bc6fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161bc6fd",
  null
  
)

export default component.exports